import React, { useState, useEffect } from "react";

import axios from "../../api/axios";
import { PALETTE } from "../../common/ThemeConstants";
import HomeCover from "../components/HomeCover";
import HomeHeader from "../components/HomeHeader";
import HomeFooter from "../components/HomeFooter";
import { useAuth } from "../../auth/hook";
import HomeProgresses from "../components/HomeProgresses";
import HomeCards from "../components/HomeCards";
import HomeFeaturesTop from "../components/HomeFeaturesTop";
import HomeFeaturesBottom from "../components/HomeFeaturesBottom";
import HomeGetStarted from "../components/HomeGetStarted";

export default function Home() {
  const auth = useAuth();
  const [categories, setCategories] = useState([]);
  const [isLogged, setIsLogged] = useState(auth.user.id !== -1);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get("/categoryList/", {
        headers: {
          Authorization: localStorage.getItem("jwt"),
        },
      })
      .then((res) => {
        const categoriesData = res.data;
        setCategories(categoriesData);
        setIsLogged(auth.user.id !== -1);
      })
      .catch((err) => {
        console.log(err);
        setIsLogged(false);
      });
  }, [auth.user]);

  return (
    <div>
      <HomeHeader categories={categories} isLogged={isLogged} />
      <div>
        <HomeCover />
        <div id="services" style={{ background: PALETTE.GRADIENTLIGHT, paddingTop: "5.5rem", paddingBottom: "5.5rem" }}>
          <HomeFeaturesTop />
        </div>
        <div style={{ paddingTop: "5.5rem", paddingBottom: "5.5rem" }}>
          <HomeFeaturesBottom />
        </div>
        <div style={{ background: PALETTE.GRADIENTLIGHT, paddingTop: "5.5rem", paddingBottom: "5.5rem" }}>
          <HomeCards categories={categories} />
        </div>
        <div style={{ paddingTop: "5.5rem", paddingBottom: "5.5rem" }}>
          <HomeProgresses categories={categories} />
        </div>
        <div style={{ background: PALETTE.GRADIENTLIGHT, paddingTop: "5.5rem", paddingBottom: "5.5rem" }}>
          <HomeGetStarted />
        </div>
        <div>
          <HomeFooter categories={categories} />
        </div>
      </div>
    </div>
  );
}
